<template>
  <PageLayout>
    <template #header>
      <div></div>
    </template>
    <template #headerCenter> <div class="hidden"></div> </template>

    <!-- main content with max width on desktop -->
    <div class="max-w-6xl mx-auto">
      <div class="sticky top-0">
        <AdsList />
      </div>

      <div class="-mt-28"></div>
      <div
        class="bg-primar rounded-b-4xl bg-linear-to-b from-primary to-primary-200 pt-24"
      >
        <div class="px-6 pt-4 pb-8 relative">
          <!-- balance card -->
          <div class="hidden">
            <div class="flex justify-between items-start mb-3">
              <div>
                <div class="text-white/80 text-sm font-medium mb-1">
                  Total Bonus
                </div>
                <div
                  class="text-white text-3xl font-bold font-outfit tracking-tight"
                >
                  0 FCFA
                </div>
              </div>
              <button
                class="flex items-center gap-2 bg-white text-primary px-4 py-2.5 rounded-xl font-semibold text-sm shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                >
                  <path d="M5 12h14m-4-4l4 4-4 4" />
                </svg>
                Retirer
              </button>
            </div>
          </div>

          <div class="mt-4"></div>
          <ServicesShortcut2 />

          <!-- social bots section -->
          <div class="mt-6 grid grid-cols-2 gap-4">
            <a
              :href="$stores.appData.state?.data?.general?.whatsappBotLink || '#'"
              target="_blank"
              class="flex items-center px-4 gap-3 py-4 rounded-2xl transition-all duration-300 border shadow-sm group"
              :class="$stores.appData.state?.data?.general?.whatsappBotLink ? 'bg-white hover:bg-green-50 border-green-100 active:scale-95' : 'bg-gray-50 border-gray-100 cursor-not-allowed opacity-60'"
              @click="!$stores.appData.state?.data?.general?.whatsappBotLink && $event.preventDefault()"
            >
              <ColorImg
                src="/images/icons/whatsapp.svg"
                class="w-6 h-6 bg-current transition-colors"
                :class="$stores.appData.state?.data?.general?.whatsappBotLink ? 'text-[#25D366]' : 'text-gray-400'"
              />
              <div class="flex flex-col text-left">
                <span class="text-[9px] uppercase tracking-widest font-black opacity-40" :class="$stores.appData.state?.data?.general?.whatsappBotLink ? 'text-green-700' : 'text-gray-500'">Disponible</span>
                <span class="font-bold text-sm" :class="$stores.appData.state?.data?.general?.whatsappBotLink ? 'text-[#070C4C]' : 'text-gray-400'">Bot WhatsApp</span>
              </div>
            </a>

            <a
              :href="$stores.appData.state?.data?.general?.telegramBotLink || '#'"
              target="_blank"
              class="flex items-center px-4 gap-3 py-4 rounded-2xl transition-all duration-300 border shadow-sm group"
              :class="$stores.appData.state?.data?.general?.telegramBotLink ? 'bg-white hover:bg-blue-50 border-blue-100 active:scale-95' : 'bg-gray-50 border-gray-100 cursor-not-allowed opacity-60'"
              @click="!$stores.appData.state?.data?.general?.telegramBotLink && $event.preventDefault()"
            >
              <ColorImg
                src="/images/icons/telegram_1.svg"
                class="w-6 h-6 bg-current transition-colors"
                :class="$stores.appData.state?.data?.general?.telegramBotLink ? 'text-[#0088cc]' : 'text-gray-400'"
              />
              <div class="flex flex-col text-left">
                <span class="text-[9px] uppercase tracking-widest font-black opacity-40" :class="$stores.appData.state?.data?.general?.telegramBotLink ? 'text-blue-700' : 'text-gray-500'">Disponible</span>
                <span class="font-bold text-sm" :class="$stores.appData.state?.data?.general?.telegramBotLink ? 'text-[#070C4C]' : 'text-gray-400'">Bot Telegram</span>
              </div>
            </a>
          </div>
        </div>
      </div>

      <!-- services section -->
      <!-- <div class="px-6 mt-4 mb-2 md:p-8">
        <div class="mb-4 md:mb-6 flex justify-between items-center">
          <div class="flex items-center gap-2 md:gap-3">
            <ColorImg
              src="/images/icons/services-list.svg"
              class="w-6 h-6 md:w-7 md:h-7 bg-current text-[#070C4C]"
            />
            <div class="text-[#070C4C] text-lg md:text-xl font-bold">
              Services
            </div>
          </div>
          <router-link class="description-color" to="/services">
            <ColorImg
              src="/images/icons/right-arrow.svg"
              class="w-4 h-4 text-[#070C4C] bg-current"
            />
          </router-link>
        </div>
        <ServicesShortcut />
      </div> -->

      <!-- live matches section -->
      <!-- <div class="px-6 mt-4 mb-2 md:p-8">
        <div class="mb-4 md:mb-6 flex justify-between">
          <div class="flex items-center gap-2 md:gap-3">
            <ColorImg
              src="/images/icons/live-match.svg"
              class="w-6 h-6 md:w-7 md:h-7 bg-current text-[#070C4C]"
            />
            <div class="text-[#070C4C] text-lg md:text-xl font-bold">
              Matches Live
            </div>
          </div>
          <button
            class="text-[#070C4C] font-medium"
            v-bus:EVENTS.MATCH.SH0W_ALL.click
          >
            Tous
          </button>
        </div>
        <LiveMatches />
      </div> -->

      <!-- transactions section -->
      <div class="bg-white/10 relative"
      style="background: linear-gradient(to bottom, transparent, #fffa 100px);"
      >
        <div class="px-6 mt-8 mb-2 md:p-8">
          <div class="mb-4 md:mb-6 flex justify-between">
            <div class="flex items-center gap-2 md:gap-3">
              <ColorImg
                src="/images/icons/live-match.svg"
                class="w-6 h-6 md:w-7 md:h-7 bg-current text-[#070C4C]"
              />
              <div class="text-[#070C4C] text-lg md:text-xl font-bold">
                Transactions
              </div>
            </div>
            <!-- <button
               class="text-[#070C4C] font-medium"
               v-bus:EVENTS.MATCH.SH0W_ALL.click
             >
               Tous
             </button> -->
          </div>
        </div>
        <TransactionList />
      </div>
    </div>
  </PageLayout>
</template>

<script>
export default {
  methods: {
    getGreeting() {
      const hour = new Date().getHours();
      return hour < 18 ? 'Bonjour' : 'Bonsoir';
    }
  }
};
</script>
